import { FaSearch, FaPencilAlt, FaRocket, FaChartLine, FaExpand } from "react-icons/fa";

export default function Section4() {
  const steps = [
    {
      title: "Step 1: Discovery & Strategy",
      description:
        "We begin by analyzing your audience, industry, and business goals to create a tailored roadmap for your campaigns.",
      icon: FaSearch
    },
    {
      title: "Step 2: Design & Copywriting",
      description:
        "Our team crafts persuasive content and custom-designed templates that engage your audience and reflect your brand identity.",
      icon: FaPencilAlt
    },
    {
      title: "Step 3: Automation Setup & Launch",
      description:
        "From welcome sequences to abandoned cart flows, we set up and launch automated campaigns that drive consistent engagement.",
      icon: FaRocket
    },
    {
      title: "Step 4: Performance Tracking & Optimization",
      description:
        "We monitor results, run A/B tests, and use analytics to continually improve your campaign performance.",
      icon: FaChartLine
    },
    {
      title: "Step 5: Scaling & Expansion",
      description:
        "Once the foundation is strong, we expand your reach with advanced segmentation, list growth, and strategies for maximum ROI.",
      icon: FaExpand
    }
  ];

  return (
    <div className="Section4 py-[50px] md:py-[80px] bg-[#f9f9f9]">
      <div className="text-center mb-12">
        <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
          Our Proven Email Marketing Process
        </h2>
        <p className="mt-8 text-[#373737] text-[16px] font-semibold md:text-[18px]">
          Quick Snapshot: Discovery → Creative → Automation → Optimization → Scale
        </p>
      </div>

      <div className="flex flex-wrap justify-center items-stretch gap-6 w-[90%] md:w-[85%] mx-auto">
        {steps.map((step, index) => {
          const Icon = step.icon;
          const isRedCard = (index + 1) % 2 !== 0; // Odd cards are red

          return (
            <div
              key={index}
              className={`p-[10%] xs:p-[4%] md:p-[3%] w-full xs:w-[40%] md:w-[30%] min-[1150px]:w-[26%] rounded-lg ${
                isRedCard
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
              } shadow-lg flex flex-col items-center`}
            >
              {/* Icon with conditional color */}
              <Icon
                className={`w-6 h-6 md:w-8 md:h-8 mb-3 ${
                  isRedCard ? "text-white" : "text-[#DA2128]"
                }`}
              />

              <h3 className="md:text-[25px] text-[20px] leading-[24px] capitalize font-bold md:leading-[30px] pb-[4%] my-[0.67em] text-center">
                {step.title}
              </h3>
              <p className="text-[12px] md:text-[14px] mb-5 font-open text-center">
                {step.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
